// Entry bundle for vr page
// Packaging-first: preserve existing CDN/global scripts. Gradually move safe local scripts here.

import he from 'he';
if (typeof window !== 'undefined') {
  window.he = he;
}

// Wave-1: bundle safe local utility scripts (preserve original load order relative to HTML)
// These do not depend on DOM being present; they attach to window or register utilities.
import '../../js/MarketHoursUtility.js';
import '../../js/PolygonAPIManagerV2.js';
import '../../js/PVTechAPIManagerV5.js';
import '../../js/CompanyIconAPIManager.js';
import '../../js/NewsProxyAPIManager.js';
import '../../js/RightPanelProxyAPIManager.js';
import '../../js/NewsapiAPIManager.js';
import '../../js/MediastackAPIManager.js';
import '../../js/panel-look-center.js';
import '../../vr_cube/StockCubePlacements.js';
import '../../vr_cube/panels-sliding-manager.js';

import '../../js/live-chart-shared/LiveChartAPIManager.js';
import '../../js/auto-refresh-scheduler-shared.js';
import '../../js/live-chart-shared/TradingViewCore.js';
import '../../vr_scripts/tradingview-universal-chart-v2.js';

import '../../js/new-graph-shared/news-graph-utils.js';
import '../../js/new-graph-shared/news-graph-physics.js';
import '../../js/new-graph-shared/news-graph-builder.js';
import '../../js/new-graph-shared/news-graph-auto-rotate.js';
import '../../vr_cube/news-graph/news-graph-visualizer.js';
import '../../vr_cube/news-graph/rotation-utils.js';
import '../../vr_cube/news-graph/legend-panel.js';
import '../../vr_cube/news-graph/overview-panel.js';
import '../../vr_cube/news-graph/controller.js';

// Wave-2a: additional safe side-effect imports migrated from HTML script tags
import '../../js/ui-input.js';
import '../../js/ui-dropdown.js';
import '../../js/ui-datepicker.js';
import '../../js/rounded-plane.js';
import '../../js/rounded-box.js';
import '../../js/sector-selector.js';
import '../../js/user-menu.js';
import '../../js/stock-menu-panel.js';
import '../../js/shooting-stars.js';
import '../../js/realistic-starfield.js';
import '../../js/app-state-display.js';
import '../../js/cube-handler.js';
import '../../js/aframe-candlestick-chart.js';
import '../../js/TickerNewsPlacements.js';
import '../../js/ui-handler.js';

// Wave-2b: side-effect imports from vr_scripts and vr_cube
import '../../vr_scripts/drag-move.js';
import '../../vr_cube/drag-rotate-y.js';
import '../../vr_scripts/info-popup.js';
import '../../vr_cube/rounded-triangle.js';
import '../../vr_cube/main-elements-moving.js';

// Wave-3: VR cube-specific scripts from HTML
// import '../../vr_scripts/ticker-news.js';
import '../../vr_cube/ticker-news.js';
import '../../vr_cube/data-interval-control.js';
import '../../vr_scripts/ui-button.js';
import '../../vr_cube/rotation-controls.js';
import '../../vr_cube/predefined-rotation-control.js';
import '../../vr_scripts/sectors-dividing-control.js';
import '../../vr_cube/stock-bar.js';
import '../../vr_cube/timeline-control.js';
import '../../vr_cube/camera-rig-handler-v4.js';
import '../../js/stock-cube-visualizer-shared/index.js';
import '../../js/market-map-shared/constants.js';
import '../../js/market-map-shared/layout.js';
import '../../js/market-map-shared/rendering.js';
import '../../js/market-map-shared/mode-switching.js';
import '../../vr_cube/stock-cube-visualizer/stock-cube-visualizer-vr.js';
import '../../js/fireworks-shared/fireworks-controller-2.js';
import '../../vr_cube/main-menu.js';
import '../../vr_cube/right-container-control.js';
import '../../vr_scripts/right-configure-popup.js';
import '../../vr_cube/extra-menu-buttons.js';
import '../../vr_scripts/segments-control.js';
import '../../vr_scripts/sectors-control.js';
import '../../vr_cube/configure-control.js';
import '../../vr_cube/left-panel-2.js';
import '../../vr_scripts/sip-filters.js';
import '../../vr_scripts/right-average-volume-chart.js';
import '../../vr_scripts/rp-performance-tab.js';
import '../../vr_scripts/rp-profile-tab.js';
import '../../vr_scripts/right-panel-data-handler.js';
import '../../vr_cube/chart-type-control.js';
import '../../vr_cube/ios-vr.js';

// Wave-4: Remaining local scripts from vr.html (maintaining approximate load order)
import '../../vr_cube/watchlist/state.js';
import '../../js/watchlist-requests.js';
import '../../vr_cube/watchlist/utils.js';
import '../../vr_cube/watchlist/summary.js';
import '../../vr_cube/watchlist/manager.js';
import '../../vr_cube/watchlist/csv-parser.js';
import '../../vr_cube/watchlist/swith-table-chart.js';
import '../../vr_cube/table.js';
import '../../vr_cube/watchlist/table.js';
import '../../vr_cube/watchlist/table-controler.js';
import '../../vr_cube/watchlist/edit-watchlist.js';
import '../../vr_cube/watchlist/main-empty-state.js';
import '../../vr_cube/watchlist/popup.js';
import '../../vr_cube/watchlist/settings-popup.js';
import '../../vr_cube/rp-financials-tab.js';
import '../../vr_scripts/search-handler.js';
import '../../vr_cube/search-mode.js';
import '../../vr_cube/main-settings.js';
import '../../vr_cube/reposition-popup.js';
import '../../vr_cube/top-menu-controls.js';
import '../../vr_cube/popup-manager.js';
import '../../vr_cube/banners.js';
import '../../js/auto-orient-billboards.js';
import '../../vr_cube/account/cookie-consent.js';
import '../../vr_cube/account/auth-ui.js';
import '../../vr_cube/account/account-input.js';
import '../../vr_cube/account/email-confirmation-modal.js';
import '../../vr_cube/account/device-link-ui.js';
import '../../vr_cube/account/account-theme.js';
import '../../js/watchlist-stock-data-processing.js';
import '../../vr_cube/tutorial-native.js';
import '../../vr_cube/tutorial.js';

// Helper function for cookies (from vr.html)
function getCookie(name) {
  if (typeof document === 'undefined') return '';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
}

// WebSocket auto-reload for development (from vr.html)
if (typeof window !== 'undefined') {
  (function setupWebSocket() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const urlPasscode = urlParams.get('passcode');
      const passcode = urlPasscode || getCookie('passcode') || '';
      let host = location.host;
      if (!host.startsWith('ws.') && !host.startsWith('localhost') && !host.match(/^\d/)) {
        host = 'ws.' + host;
      }
      const wsUrl = passcode
        ? `wss://${host}/?passcode=${encodeURIComponent(passcode)}`
        : `wss://${host}`;

      console.log('WebSocket connecting to:', wsUrl);
      const ws = new WebSocket(wsUrl);

      ws.onmessage = (event) => {
        if (event.data === 'reload') {
          console.log('Received reload message, refreshing page');
          location.reload();
        }
      };
      ws.onping = () => {
        console.log('Received ping from server');
        ws.pong();
      };
      ws.onopen = () => console.log('WebSocket connected');
      ws.onerror = (error) => console.error('WebSocket error:', error);
      ws.onclose = () => console.log('WebSocket closed');
    } catch (e) {
      console.warn('WebSocket setup failed:', e);
    }
  })();
}


// Initialize page after bundle is loaded
(function initializeVr2Cube() {
  function runInitialization() {
    // Call startupTickerNews if available
    if (typeof window.startupTickerNews === 'function') {
      window.startupTickerNews();
    }

    // Initialize center panel content
    const centerContent = document.getElementById('large-center-panel-content');
    if (centerContent) {
      centerContent.replaceChildren();
      centerContent.setAttribute('position', '0 0 0');
    }

    // Auto-center button logic from vr.html
    const autoCenterButton = document.getElementById('auto-center');
    const scene = document.querySelector('a-scene');
    if (autoCenterButton && scene) {
      let isAutoCenterOn = false;
      autoCenterButton.addEventListener('click', () => {
        isAutoCenterOn = !isAutoCenterOn;
        if (isAutoCenterOn) {
          autoCenterButton.setAttribute('ui-button', 'label', 'Auto Zoom Off');
          scene.setAttribute('panel-look-center', 'enabled', true);
        } else {
          autoCenterButton.setAttribute('ui-button', 'label', 'Auto Zoom');
          scene.setAttribute('panel-look-center', 'enabled', false);
        }
      });
    }

    // Info-popup manual registration workaround from vr.html
    if (scene && window.PopupManager) {
      const infoPopup = document.querySelector('#info-popup');
      const registerInfoPopup = () => {
        if (infoPopup) {
          window.PopupManager.register('info-popup', infoPopup, {
            onOpen: function () {
              infoPopup.setAttribute('position', '-1.17 2.05 -0.8');
              if (infoPopup.components && infoPopup.components['info-popup']) {
                infoPopup.components['info-popup'].open();
                if (infoPopup.components['info-popup'].popupOpenedTime !== undefined) {
                  infoPopup.components['info-popup'].popupOpenedTime = Date.now();
                }
              }
            }
          });
          console.log('[Fix] Manually registered info-popup via bundle');
        }
      };
      if (scene.hasLoaded) registerInfoPopup();
      else scene.addEventListener('loaded', registerInfoPopup);
    }

    // Auto-enter VR mode if in true VR mode state (from vr.html)
    // scene.addEventListener('loaded', () => {
    //   if (window.AppState && window.AppState.isTrueVRMode && !scene.is('vr-mode')) {
    //     setTimeout(() => {
    //       scene.enterVR();
    //       console.log('Automatically entered true VR mode after delay');
    //     }, 1000);
    //   }
    // }, { once: true });

    // Renderer logging for debugging
    if (scene) {
      scene.style.visibility = 'visible';
      const logRenderer = () => {
        const renderer = scene.renderer;
        if (renderer) {
          console.log('Renderer info:', {
            antialias: renderer.getContext().getContextAttributes().antialias,
            pixelRatio: renderer.getPixelRatio(),
            size: renderer.getSize(new (window.THREE ? window.THREE.Vector2 : Object)()),
            capabilities: renderer.capabilities
          });
        }
      };
      if (scene.hasLoaded) logRenderer();
      else scene.addEventListener('loaded', logRenderer);
    }
  }

  if (typeof window !== 'undefined') {
    // Use DOMContentLoaded to ensure DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitialization);
    } else {
      // DOM already loaded, run immediately
      setTimeout(runInitialization, 0);
    }
  }
})();

// First lazy-loaded chunk example (non-critical visual flair)
// Defer fireworks registration until after scene is loaded to keep initial payload smaller.
if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    const scene = document.querySelector('a-scene');
    if (scene) {
      const onLoaded = () => {
        import(/* webpackChunkName: "feature.fireworks" */ '../../js/fireworks-shared/fireworks-lib-2.js')
          .then(() => console.log('Lazy-loaded: fireworks'))
          .catch((e) => console.warn('Failed to lazy-load fireworks:', e));
      };
      if (scene.hasLoaded || scene.is && scene.is('loaded')) onLoaded();
      else scene.addEventListener('loaded', onLoaded, { once: true });
    }
  });
}

setCacheItem('preferred-page', 'vr', 60 * 60 * 24 * 30); // 30 days

console.log('StockStorm: vr-cube bundle loaded');
